// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { classNames, createElement, Component, PropTypes, Translate, Alert, Button, Popover, Item, Icon } from '@plesk/ui-library';

const STATUS_DEFAULT = 'default';
const STATUS_TEST = 'test';
const STATUS_TRIAL = 'trial';
const STATUS_EXPIRED = 'expired';

class LicenseStatus extends Component {
    constructor(props) {
        super(props);

        this.state = {
            trialOverPopoverVisible: this.props.daysLeft <= 5 && this.props.hidePopoverUrl,
        };

        this.handleClosePopover = this.handleClosePopover.bind(this);
    }

    handleClosePopover() {
        this.setState({ trialOverPopoverVisible: false });
        const { hidePopoverUrl } = this.props;
        new Ajax.Request(hidePopoverUrl, { method: 'post' });
    }

    renderDaysCounter() {
        const { status, daysLeft, baseClassName } = this.props;

        return STATUS_TRIAL === status ? (<div className={`${baseClassName}-alert__message-count`}>{daysLeft}</div>) : null;
    }

    renderActions() {
        const { actionUrl, installUrl, status, baseClassName } = this.props;
        const alertCls = `${baseClassName}-alert`;

        return (actionUrl || installUrl) ? (
            <div className={`${alertCls}__actions`}>
                {actionUrl && (
                    <Button
                        intent="primary"
                        component="a"
                        icon="shopping-cart"
                        className={`${alertCls}__actions-button`}
                        href={actionUrl}
                        target="_blank"
                    >
                        <Translate content={status === STATUS_DEFAULT ? 'getTrialButton' : 'buyLicenseButton'} />
                    </Button>
                )}
                {installUrl && (
                    <Button
                        component="a"
                        baseClassName={`${alertCls}__actions-link`}
                        href={installUrl}
                    >
                        <Translate content="installLicenseButton" />
                    </Button>
                )}
            </div>
        ) : null;
    }

    renderTrialPopover(content) {
        const { trialOverPopoverVisible } = this.state;
        const { trialOverIcon, baseClassName } = this.props;
        const popoverCls = `${baseClassName}-popover`;

        return trialOverPopoverVisible ? (
            <Popover
                className={popoverCls}
                visible
                onClose={this.handleClosePopover}
                target={content}
            >
                <Item
                    title={<h4><Translate content="trialOverTitle" /></h4>}
                    icon={<Icon size="lg" src={trialOverIcon} />}
                >
                    <Translate content="trialOverText" />
                </Item>
            </Popover>
        ) : content;
    }

    render() {
        const { daysLeft, isAdmin, status, baseClassName } = this.props;
        const { trialOverPopoverVisible } = this.state;
        const alertCls = `${baseClassName}-alert`;

        const content = (
            <div className={classNames(baseClassName, { 'license-status--active': trialOverPopoverVisible })}>
                <Alert
                    className={alertCls}
                    intent={daysLeft <= 0 ? 'danger' : (daysLeft <= 5 ? 'warning' : null)}
                >
                    <div className={`${alertCls}__inner`}>
                        <div className={`${alertCls}__message`}>
                            {this.renderDaysCounter()}
                            <div className={`${alertCls}__message-text`}>
                                <Translate content={isAdmin ? `${status}LicenseWarningAdmin` : 'testLicenseWarningClient'} />
                            </div>
                        </div>
                        {this.renderActions()}
                    </div>
                </Alert>
            </div>
        );

        return this.renderTrialPopover(content);
    }
}

LicenseStatus.propTypes = {
    status: PropTypes.oneOf([STATUS_DEFAULT, STATUS_TEST, STATUS_TRIAL, STATUS_EXPIRED]).isRequired,
    daysLeft: PropTypes.number,
    isAdmin: PropTypes.bool.isRequired,
    actionUrl: PropTypes.string,
    installUrl: PropTypes.string,
    hidePopoverUrl: PropTypes.string,
    trialOverIcon: PropTypes.string,
    baseClassName: PropTypes.string,
};

LicenseStatus.defaultProps = {
    daysLeft: 0,
    actionUrl: null,
    installUrl: null,
    hidePopoverUrl: null,
    trialOverIcon: null,
    baseClassName: 'license-status',
};

export default LicenseStatus;



// WEBPACK FOOTER //
// ./app/license-status/LicenseStatus.js